module.exports = new __parcel__URL__("menu-help.5495a66d.svg").toString();